/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import CategoryChipsMenu from 'components/CategoryChipsMenu/CategoryChipsMenu';
import Hero from 'components/Hero/Hero';
import ShowcaseVoucher from 'components/ShowcaseVoucher';
import ShowcaseServices from 'components/ServicesBannersForHome/components/CarouselBannersService/ShowcaseServices';
import ShowcaseStore from 'components/StoresShowcase/ShowcaseStore';
import ShowCaseAutomate from 'components/ShowCaseAutomate/ShowCaseAutomate';
import { ShowcaseDisplayAreaEnum } from 'Constants/ShowCaseConstants';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import { useDispatch, useSelector } from 'react-redux';

import GiftBanner from 'components/GiftBanner';
import { VertContainer } from '@vertem-core/vertice-ds';
import GiftInformativeModal from 'components/GiftInformativeModal';
import ynToBool from 'Utils/ynToBool';
import BannerSupplier from '../../components/BannerSupplier';
import FilterPointsCarrousel from 'components/FilterPointsCarroussel';
import ModalPopBallon from 'components/Modal/ModalPopBallon';
import {
  hasAccepted,
  getAvailableBallons,
  getBallonsByParticipant,
} from 'redux/Reducers/PopBallon/VertemGiftApi';
import VertemGiftInformativeModal from 'components/PopBallon/VertemGiftInformativeModal';
import useActiveCampaign from 'Hooks/useVertemGift';
import InformationModal from 'components/Modal/InformationModal';
import useGiftCardParticipant from 'Hooks/useGiftParticipant';

const HomePage = () => {
  const dispatch = useDispatch();
  const { isCampaignActive } = useActiveCampaign();
  const { participantGroups } = useParticipantSubSegment();
  const {
    isBannerOfGiftsVisible,
    isModalOfGiftsVisible,
    setIsModalOfGiftsVisible,
    isInformativeOfVertemGiftsVisible,
    setIsInformativeOfVertemGiftsVisible,
  } = useGiftCardParticipant();

  const [isOpenModalInformation, setIsOpenModalInformation] = useState(false);

  const [isModalOfVertemGiftsVisible, setIsModalOfVertemGiftsVisible] = useState(false);
  const { hasAcceptedTerm } =
    useSelector((state) => state.VertemGift);
  const Catalog = useSelector(({ Catalog: data }) => data);
  const {
    currencyConfiguration: { pointsName },
  } = Catalog;

  const getInformationModalGroups = () => {
    if (process.env.REACT_APP_INFORMATION_MODAL_GROUPS) {
      let groupsCTG = participantGroups.map((group) => {
        return group.name;
      });

      let informationModalGroups = process.env.REACT_APP_INFORMATION_MODAL_GROUPS.trim().split(',').map((group) => group.trim());

      let result = groupsCTG.some((groupName) => informationModalGroups.includes(groupName));

      return result;
    }
    return true;
  };

  useEffect(() => {
    const hasInformationModal = ynToBool(process.env.REACT_APP_HAS_INFORMATION_MODAL);

    if (!hasInformationModal) return;

    if (getInformationModalGroups()) {
      setIsOpenModalInformation(true);
    }

    return () => {
      setIsOpenModalInformation(false);
    }
  }, []);

  useEffect(() => {
    if (ynToBool(process.env.REACT_APP_HAS_VERTEM_GIFT)) {
      if (isCampaignActive) {
        dispatch(hasAccepted());
        dispatch(getAvailableBallons());
        dispatch(getBallonsByParticipant());
      }
    }
  }, [isCampaignActive]);

  useEffect(() => {
    if (ynToBool(process.env.REACT_APP_HAS_VERTEM_GIFT)) {
      if (typeof hasAcceptedTerm !== 'undefined' && hasAcceptedTerm !== null) {
        setIsModalOfVertemGiftsVisible(!hasAcceptedTerm);
      }
    }
  }, [hasAcceptedTerm, isCampaignActive]);

  const onModalGiftVertemCancel = () => {
    setIsModalOfVertemGiftsVisible(false);
  };

  const onInformativeGiftVertemCancel = () => {
    setIsInformativeOfVertemGiftsVisible(false);
  };

  return (
    <>
      <div className="home">
        <ShowCaseAutomate
          idDisplayAreaId={ShowcaseDisplayAreaEnum.TOP_HOMEPAGE}
        />
        <Hero />
        {ynToBool(process.env.REACT_APP_SHOW_CATEGORIES_CARROUSEL) && (
          <>
            <CategoryChipsMenu />
          </>
        )}

        <FilterPointsCarrousel
          type="showcase-by-value"
          title={`Filtre por ${pointsName}`}
        />
        {isCampaignActive &&
          !ynToBool(process.env.REACT_APP_HIDE_MODAL_TERMS_POP_BALLON) && (
            <ModalPopBallon
              isOpen={isModalOfVertemGiftsVisible}
              onCancel={() => onModalGiftVertemCancel()}
            />
          )}
        <BannerSupplier />


        <InformationModal
          isOpen={isOpenModalInformation}
          onCancel={() => setIsOpenModalInformation(false)}
          title={process.env.REACT_APP_INFORMATION_TEXT_MODAL}
        />

        <ShowcaseServices type="services" />
        <ShowCaseAutomate
          idDisplayAreaId={ShowcaseDisplayAreaEnum.MIDDLE_HOMEPAGE}
        />
        {!ynToBool(process.env.REACT_APP_DISABLE_VOUCHER_SHOWCASE) && (
          <>
            <ShowcaseVoucher type={7} identifier="home" />
          </>
        )}
        {isBannerOfGiftsVisible && (
          <VertContainer spacingY="small">
            <GiftBanner
              titleText='Você tem um brinde para resgatar!'
              subtitleText='Aproveite antes que expire!'
              hasButton
              buttonText={'Resgatar Agora'}
            />
          </VertContainer>
        )}

        {ynToBool(!process.env.REACT_APP_HIDE_STORES) && <ShowcaseStore />}
        
        <ShowCaseAutomate
          idDisplayAreaId={ShowcaseDisplayAreaEnum.BOTTOM_HOMEPAGE}
        />

        <GiftInformativeModal
          isOpen={isModalOfGiftsVisible}
          onCancel={() => setIsModalOfGiftsVisible(false)}
        />

        <VertemGiftInformativeModal
          isOpen={isInformativeOfVertemGiftsVisible}
          onCancel={() => onInformativeGiftVertemCancel()}
        />
      </div>
    </>
  );
};

export default HomePage;
